import { render, staticRenderFns } from "./DuoRedirectHandler.vue?vue&type=template&id=020610c3&"
import script from "./DuoRedirectHandler.vue?vue&type=script&lang=ts&"
export * from "./DuoRedirectHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports